<mat-card class="info-card">
  <mat-card-title class="title">
    <div class="flex-row">
      <span style="padding-left: 8px">{{ title ? title : ("Activity" | translate) }}</span>
      @if (showCreateActivityButton) {
      <button mat-icon-button class="add-activity-button" (click)="openCreateActivityModal()">
        <svg-icon src="/assets/icons/icon-16-add.svg"></svg-icon>
      </button>
      }
    </div>
  </mat-card-title>
  <mat-card-content>
    <div>
      @if (isHistoryLoaded) {
      <ul class="timeline">
        @for (item of displayedTimeLine; track item) {
        <li>
          <svg-icon src="{{ getActivityIcon(item.activity) }}"></svg-icon>
          <div class="timeline-text">
            <span class="timeline-header" [innerHTML]="item.text | formatting"></span><br />
            <span class="timestamp">{{ formatDate(item.timestamp) }}</span>
          </div>
        </li>
        }
      </ul>
      } @if (!isHistoryLoaded) {
      <div class="timeline">
        <mat-spinner class="auto-margin spinner-position"></mat-spinner>
      </div>
      }
    </div>
    <mat-paginator
      (page)="triggerPageChange($event)"
      class="historyPagination"
      [pageSize]="pageSize"
      [length]="timeline?.length"
      [hidePageSize]="true"
    ></mat-paginator>
  </mat-card-content>
</mat-card>
